import type { Transition } from "@uirouter/core";

import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";

import { leadGeneratorThreadService } from "../services/thread";
import type LeadGeneratorThreadPrefetchService from "../services/thread/threadPrefetchService";

export interface ILeadGeneratorRoutingHooks {
    onEnterPrefetchThread: (transition: Transition) => Promise<void>;
}

/**
 * Factory function to create routing hooks for lead generator module
 */
export function createLeadGeneratorRoutingHooks(
    prefetchService: LeadGeneratorThreadPrefetchService,
): ILeadGeneratorRoutingHooks {
    /**
     * UI Router onEnter hook for prefetching lead generator thread
     * @param transition - UI Router transition containing route params
     */
    const onEnterPrefetchThread = async (transition: Transition): Promise<void> => {
        const savedSearchId = (transition.params() as Partial<SavedSearchRoutingParams>)?.savedSearchId;

        const existingThreadId = leadGeneratorThreadService.getExistingThreadId({ savedSearchId });

        if (existingThreadId) {
            return;
        }

        return prefetchService.prefetchThread({ savedSearchId });
    };

    return {
        onEnterPrefetchThread,
    };
}
